// extracted by mini-css-extract-plugin
export default {"popup":"InlineActionPopup_popup__m4gM0"};